import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GroupByPipe } from './pipes/group-by.pipe';
import { NullDefaultValueDirective } from './directives/null-default-value.directive';
import { MustMatchDirective } from './directives/must-match.directive';
import { DatepickerModule } from './datepicker/datepicker.module';
import { ToastModule } from './toast/toast.module';
import { OrderByPipe } from './pipes/order-by-pipe';
import { PaginationModule } from './pagination/pagination.module';
import { ModalModule } from './modal/modal.module';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { SharedModule } from '../shared/shared.module';
import { SpinnerModule } from './spinner/spinner.module';
import { HasAdditionalAccessRightDirective } from './directives/has-additional-access-right.directive';
import { HasRoleDirective } from './directives/is-in-role-directive';

@NgModule({
    declarations: [GroupByPipe, OrderByPipe, NullDefaultValueDirective, MustMatchDirective, HasAdditionalAccessRightDirective, HasRoleDirective],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        DatepickerModule,
        ToastModule,
        PaginationModule,
        ModalModule,
        BreadcrumbModule,
        SpinnerModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        GroupByPipe,
        OrderByPipe,
        NullDefaultValueDirective,
        MustMatchDirective,
        DatepickerModule,
        ToastModule,
        PaginationModule,
        ModalModule,
        BreadcrumbModule,
        SpinnerModule,
        HasAdditionalAccessRightDirective,
        HasRoleDirective,
        SharedModule
    ]
})
export class CoreModule { }
